import { render, staticRenderFns } from "./CardBase.vue?vue&type=template&id=4b063dfc&scoped=true&"
import script from "./CardBase.vue?vue&type=script&lang=js&"
export * from "./CardBase.vue?vue&type=script&lang=js&"
import style0 from "./CardBase.vue?vue&type=style&index=0&id=4b063dfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b063dfc",
  null
  
)

export default component.exports